import { useResolve } from '@visiba/instantiation';
import { FeatureFlagService } from './feature_flag.service';

export function useFeatureFlag<T extends ExpectedFlags>(flag: keyof T): boolean {
	const featureToggleService = useResolve(FeatureFlagService<T>);

	let expectedFlag: boolean;
	try {
		expectedFlag = featureToggleService.checkFlag(flag);
	} catch {
		expectedFlag = false;
	}

	return expectedFlag;
}
